<router-outlet></router-outlet>
<video #sleepPrevent loop autoplay [muted]="'muted'">
  <source type="video/webm" src="data:video/webm;base64,{{ src }}" />
  <source type="video/mp4" src="data:video/mp4;base64,{{ src }}" />
</video>
